import React from "react"

import { RrsTemplateFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchRrsTemplate {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: RrsTemplateFilters
    onFilter: (filters: RrsTemplateFilters) => void
}

const RrsTemplateSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchRrsTemplate) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default RrsTemplateSearch
